import React from 'react';
import { OrderListTemplate } from 'themes/modules/order/pages';
import { OrderListViewStore } from 'modules/order/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new OrderListViewStore(rootStore), 'orderListViewStore')
class OrderList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <OrderListTemplate {...this.props} viewStore={this.props.orderListViewStore} />;
	}
}

export default OrderList;
